import { PhoneNumberUtil } from 'google-libphonenumber'
import { toLocale } from '$func/text'

// TODO review
export const normalizePhone = (phone: string) => {
  let trimmedPhone = phone.trim()
  if (!trimmedPhone) return ''

  if (trimmedPhone.match(/^[^0+]/)) trimmedPhone = `0${trimmedPhone}`

  const justStartingPlus =
    trimmedPhone[0] + trimmedPhone.substring(1).replace(/\++/g, '')
  const normalized = justStartingPlus
    .replace(/[^\d+]+/g, '')
    .replace(/^00/, '+')
    .replace(/^0/, '+98')

  return normalized.startsWith('+') ? normalized : ''
}

export const addCountryCodeToNumber = (phone: string, code: string) =>
  `+${code}${code === '98' && phone.startsWith('0') ? phone.slice(1) : phone}`

export const toHumanReadablePhone = (phone?: string, locale = true) => {
  if (!phone) return ''

  const formattedPhone = phone.replace('+98', '0')
  return locale ? toLocale(formattedPhone || '', false) : formattedPhone
}

const phoneUtil = PhoneNumberUtil.getInstance()

export const isPhoneValidByLib = (phone: string) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
  } catch (error) {
    return false
  }
}

export const isMobilePhone = (phone: string) => {
  try {
    return phoneUtil.getNumberType(phoneUtil.parseAndKeepRawInput(phone)) === 1
  } catch (error) {
    return false
  }
}
